(function () {
  function initLocator(sectionEl) {
    if (!sectionEl) return;
    sectionEl.classList.add('is-enhanced');

    var chainsContainer = sectionEl.querySelector('[data-locator-chains]');
    var searchInput = sectionEl.querySelector('[data-locator-search]');
    var regionSelect = sectionEl.querySelector('[data-locator-region]');
    var chainSelect = sectionEl.querySelector('[data-locator-chain]');
    var regionTypeahead = sectionEl.querySelector('[data-locator-region-input]');
    var chainTypeahead = sectionEl.querySelector('[data-locator-chain-input]');
    var regionDatalist = sectionEl.querySelector('[data-locator-region-list]');
    var chainDatalist = sectionEl.querySelector('[data-locator-chain-list]');
    var regionAutocomplete = null;
    var chainAutocomplete = null;
    var summaryEl = sectionEl.querySelector('[data-locator-results-summary]');
    var networkTotalEls = sectionEl.querySelectorAll('[data-locator-network-total], [data-locator-total-network], [data-locator-total-count]');
    var networkRegionEls = sectionEl.querySelectorAll('[data-locator-network-regions]');
    var resetButton = sectionEl.querySelector('[data-locator-reset]');
    var collapseAllButton = sectionEl.querySelector('[data-locator-collapse-all]');
    var filtersSummaryEl = sectionEl.querySelector('[data-locator-results-filters]');
    var lastUpdatedEl = sectionEl.querySelector('[data-locator-last-updated]');
    var mapLinkText = sectionEl.getAttribute('data-map-link-text') || 'Get directions';
    if (/^view(\s+on)?\s+map$/i.test(mapLinkText.trim())) mapLinkText = 'Get directions';
    var locationsUrl = sectionEl.getAttribute('data-locations-url');
    var contactUrl = sectionEl.getAttribute('data-contact-url') || '/pages/contact';
    var contactEmail = sectionEl.getAttribute('data-contact-email') || '';
    var chainLogos = {
      'Metro': { src: sectionEl.getAttribute('data-metro-logo') || '', alt: 'Metro Retail Stores Group logo', className: 'ag-locator__chain-logo--metro' },
      'Gaisano Grand': { src: sectionEl.getAttribute('data-gaisano-logo') || '', alt: 'Gaisano Grand Mall logo', className: 'ag-locator__chain-logo--gaisano-grand' },
      'PureGold': { src: sectionEl.getAttribute('data-puregold-logo') || '', alt: 'Puregold logo', className: 'ag-locator__chain-logo--puregold' }
    };
    var allLocations = [];
    var regionOrder = ['Luzon', 'Visayas', 'Mindanao'];
    var chainOrder = ['Metro', 'Gaisano Grand', 'PureGold'];
    var autocompleteInstanceCount = 0;

    function escapeHtml(text) {
      if (!text) return '';
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function getChainColor(chainName) {
      var colors = {
        'Metro': { className: 'ag-locator__chain-header--metro', accent: '#173a28' },
        'Gaisano Grand': { className: 'ag-locator__chain-header--gaisano-grand', accent: '#b05d34' },
        'PureGold': { className: 'ag-locator__chain-header--puregold', accent: '#3f6a4e' }
      };
      return colors[chainName] || { className: 'ag-locator__chain-header--default', accent: '#173a28' };
    }

    function getChainLogo(chainName) {
      return chainLogos[chainName] || null;
    }

    function groupByChainAndRegion(locations) {
      var grouped = {};

      locations.forEach(function (loc) {
        var chain = loc.store_chain || 'Other';
        var region = loc.store_region || 'Unknown';

        if (!grouped[chain]) {
          grouped[chain] = {
            name: chain,
            color: getChainColor(chain),
            regions: {},
            total: 0
          };
        }

        if (!grouped[chain].regions[region]) {
          grouped[chain].regions[region] = [];
        }

        grouped[chain].regions[region].push(loc);
        grouped[chain].total++;
      });

      return grouped;
    }

    function renderStoreItem(loc, mapLabel) {
      var region = (loc.store_region || '').trim();

      var html = '<article class="ag-locator__store-item">';
      html += '<div class="ag-locator__store-main">';
      html += '<h4 class="ag-locator__store-name">' + escapeHtml(loc.store_name) + '</h4>';
      if (region) {
        html += '<p class="ag-locator__store-locale">' + escapeHtml(region) + '</p>';
      }
      html += '<p class="ag-locator__store-address">' + escapeHtml(loc.store_address) + '</p>';
      if (loc.store_hours) {
        html += '<p class="ag-locator__store-hours">' + escapeHtml(loc.store_hours) + '</p>';
      }
      html += '</div>';
      if (loc.store_map_url) {
        html += '<a href="' + escapeHtml(loc.store_map_url) + '" target="_blank" rel="noopener noreferrer" class="ag-locator__store-link">';
        html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>';
        html += '<span>' + escapeHtml(mapLabel || 'Get directions') + '</span>';
        html += '</a>';
      }
      html += '</article>';
      return html;
    }

    function safeId(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    function renderChainCard(chainData, mapLabel) {
      var regions = ['Luzon', 'Visayas', 'Mindanao'];
      var logo = getChainLogo(chainData.name);
      var chainId = safeId(chainData.name);
      var html = '<article class="ag-locator__chain-card" data-chain="' + escapeHtml(chainData.name) + '">';

      html += '<div class="ag-locator__chain-header ' + chainData.color.className + '">';
      html += '<div class="ag-locator__chain-header-main">';
      if (logo && logo.src) {
        html += '<div class="ag-locator__chain-logo-wrap"><img class="ag-locator__chain-logo ' + logo.className + '" src="' + escapeHtml(logo.src) + '" alt="' + escapeHtml(logo.alt) + '"></div>';
      }
      html += '<div class="ag-locator__chain-copy">';
      html += '<h3 class="ag-locator__chain-title">' + escapeHtml(chainData.name) + '</h3>';
      html += '<p class="ag-locator__chain-note">' + chainData.total + ' Agriko stockist' + (chainData.total !== 1 ? 's' : '') + '</p>';
      html += '</div>';
      html += '</div>';
      html += '</div>';

      html += '<div class="ag-locator__chain-body">';

      regions.forEach(function (region) {
        if (chainData.regions[region] && chainData.regions[region].length > 0) {
          var regionStores = chainData.regions[region];
          var panelId = 'locator-' + chainId + '-' + safeId(region) + '-branches';
          html += '<section class="ag-locator__region-section" data-region="' + region + '">';
          html += '<button type="button" class="ag-locator__region-toggle" id="' + panelId + '-toggle" data-region-toggle="' + region + '" aria-expanded="false" aria-controls="' + panelId + '">';
          html += '<span class="ag-locator__region-leading">';
          html += '<span class="ag-locator__region-icon">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
          html += '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>';
          html += '<circle cx="12" cy="10" r="3"/>';
          html += '</svg>';
          html += '</span>';
          html += '<span class="ag-locator__region-copy">';
          html += '<span class="ag-locator__region-name">' + region + '</span>';
          html += '<span class="ag-locator__region-note">' + regionStores.length + (regionStores.length !== 1 ? ' branches' : ' branch') + '</span>';
          html += '</span>';
          html += '</span>';
          html += '<span class="ag-locator__region-trailing">';
          html += '<span class="ag-locator__region-count">' + regionStores.length + '</span>';
          html += '<span class="ag-locator__region-count-label">store' + (regionStores.length !== 1 ? 's' : '') + '</span>';
          html += '<span class="ag-locator__region-chevron">';
          html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
          html += '<polyline points="6 9 12 15 18 9"/>';
          html += '</svg>';
          html += '</span>';
          html += '</span>';
          html += '</button>';
          html += '<div class="ag-locator__region-stores" id="' + panelId + '" data-region-content="' + region + '" role="region" aria-labelledby="' + panelId + '-toggle" hidden>';

          regionStores.forEach(function (loc) {
            html += renderStoreItem(loc, mapLabel);
          });

          html += '</div>';
          html += '</section>';
        }
      });

      html += '</div>';
      html += '</article>';
      return html;
    }

    function renderChains(locations, mapLabel, options) {
      var grouped = groupByChainAndRegion(locations);
      var html = '';

      chainOrder.forEach(function (chainName) {
        if (grouped[chainName]) {
          html += renderChainCard(grouped[chainName], mapLabel, options);
        }
      });

      Object.keys(grouped).forEach(function (chainName) {
        if (chainOrder.indexOf(chainName) === -1) {
          html += renderChainCard(grouped[chainName], mapLabel, options);
        }
      });

      return html;
    }

    function populateSelect(selectEl, allLabel, values) {
      if (!selectEl) return;

      var currentValue = selectEl.value || 'all';
      var options = ['<option value="all">' + escapeHtml(allLabel) + '</option>'];

      values.forEach(function (value) {
        options.push('<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>');
      });

      selectEl.innerHTML = options.join('');

      if (values.indexOf(currentValue) !== -1) {
        selectEl.value = currentValue;
      }
    }

    function populateFilterOptions(locations) {
      var regions = [];
      var chains = [];

      locations.forEach(function (loc) {
        if (loc.store_region && regions.indexOf(loc.store_region) === -1) {
          regions.push(loc.store_region);
        }

        if (loc.store_chain && chains.indexOf(loc.store_chain) === -1) {
          chains.push(loc.store_chain);
        }
      });

      regions.sort(function (a, b) {
        var aIndex = regionOrder.indexOf(a);
        var bIndex = regionOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });

      chains.sort(function (a, b) {
        var aIndex = chainOrder.indexOf(a);
        var bIndex = chainOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });

      populateSelect(regionSelect, 'All Regions', regions);
      populateSelect(chainSelect, 'All Chains', chains);

      if (regionDatalist) {
        regionDatalist.innerHTML = regions.map(function (value) {
          return '<option value="' + escapeHtml(value) + '"></option>';
        }).join('');
      }

      if (chainDatalist) {
        chainDatalist.innerHTML = chains.map(function (value) {
          return '<option value="' + escapeHtml(value) + '"></option>';
        }).join('');
      }

      if (regionTypeahead && regionSelect) {
        regionTypeahead.value = regionSelect.value !== 'all' ? regionSelect.value : '';
      }

      if (chainTypeahead && chainSelect) {
        chainTypeahead.value = chainSelect.value !== 'all' ? chainSelect.value : '';
      }

      if (regionAutocomplete) regionAutocomplete.updateOptions(regions);
      if (chainAutocomplete) chainAutocomplete.updateOptions(chains);
    }

    function hasActiveFilters() {
      var searchTerm = searchInput ? searchInput.value.trim() : '';
      var regionFilter = regionSelect ? regionSelect.value : 'all';
      var chainFilter = chainSelect ? chainSelect.value : 'all';

      return Boolean(searchTerm) || regionFilter !== 'all' || chainFilter !== 'all';
    }

    function toggleResetButton() {
      if (!resetButton) return;
      resetButton.hidden = !hasActiveFilters();
    }

    function updateActiveFiltersSummary() {
      if (!filtersSummaryEl) return;

      var parts = [];
      var searchTerm = searchInput ? searchInput.value.trim() : '';
      var regionFilter = regionSelect ? regionSelect.value : 'all';
      var chainFilter = chainSelect ? chainSelect.value : 'all';

      if (searchTerm) parts.push('“' + searchTerm + '”');
      if (regionFilter && regionFilter !== 'all') parts.push(regionFilter);
      if (chainFilter && chainFilter !== 'all') parts.push(chainFilter);

      if (!parts.length) {
        filtersSummaryEl.textContent = '';
        filtersSummaryEl.setAttribute('aria-hidden', 'true');
        return;
      }

      filtersSummaryEl.textContent = parts.join(' · ');
      filtersSummaryEl.setAttribute('aria-hidden', 'false');
    }

    function hasOpenRegions() {
      return Boolean(sectionEl.querySelector('[data-region-toggle][aria-expanded=\"true\"]'));
    }

    function toggleCollapseAllButton() {
      if (!collapseAllButton) return;
      collapseAllButton.hidden = !hasOpenRegions();
    }

    function renderStateActions(includeReset, includeRetry) {
      var actions = [];

      if (includeReset) {
        actions.push('<button type="button" class="ag-locator__empty-action ag-locator__empty-action--primary" data-locator-reset-inline>Clear filters</button>');
      }

      if (includeRetry) {
        actions.push('<button type="button" class="ag-locator__empty-action ag-locator__empty-action--primary" data-locator-retry>Try again</button>');
      }

      if (contactUrl) {
        actions.push('<a href="' + escapeHtml(contactUrl) + '" class="ag-locator__empty-action">Ask the team</a>');
      }

      if (contactEmail) {
        actions.push('<a href="mailto:' + escapeHtml(contactEmail) + '" class="ag-locator__empty-action">' + escapeHtml(contactEmail) + '</a>');
      }

      return actions.length ? '<div class="ag-locator__empty-actions">' + actions.join('') + '</div>' : '';
    }

    function renderLoadingState() {
      return '' +
        '<div class="ag-locator__loading ag-locator__loading--skeleton" data-locations-loading>' +
          '<div class="ag-locator__loading-skeletons" aria-hidden="true">' +
            '<div class="ag-locator__loading-card">' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--wide"></span>' +
              '<span class="ag-locator__loading-card-line"></span>' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--short"></span>' +
            '</div>' +
            '<div class="ag-locator__loading-card">' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--wide"></span>' +
              '<span class="ag-locator__loading-card-line"></span>' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--short"></span>' +
            '</div>' +
            '<div class="ag-locator__loading-card">' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--wide"></span>' +
              '<span class="ag-locator__loading-card-line"></span>' +
              '<span class="ag-locator__loading-card-line ag-locator__loading-card-line--short"></span>' +
            '</div>' +
          '</div>' +
          '<p>Loading live store coverage…</p>' +
        '</div>';
    }

    function renderEmptyState(type) {
      if (type === 'error') {
        return '<div class="ag-locator__empty"><p class="ag-locator__empty-text">The live shelf list is unavailable right now.</p><p>You can retry in a moment, or ask the team to verify the nearest Agriko stockist.</p>' + renderStateActions(false, true) + '</div>';
      }

      if (type === 'timeout') {
        return '<div class="ag-locator__empty"><p class="ag-locator__empty-text">The live shelf list is taking longer than expected.</p><p>Try again, or ask the team to confirm the nearest branch.</p>' + renderStateActions(false, true) + '</div>';
      }

      if (type === 'no-data') {
        return '<div class="ag-locator__empty"><p class="ag-locator__empty-text">There are no published locations yet.</p><p>Contact the team for the nearest available stockist while the locator is being updated.</p>' + renderStateActions(false, false) + '</div>';
      }

      return '<div class="ag-locator__empty"><p class="ag-locator__empty-text">No stores matched that search.</p><p>Clear one or more filters, try a broader city or branch name, or contact the team for manual help.</p>' + renderStateActions(true, false) + '</div>';
    }

    function resetFilters() {
      if (searchInput) searchInput.value = '';
      if (regionSelect) regionSelect.value = 'all';
      if (chainSelect) chainSelect.value = 'all';
      if (regionTypeahead) regionTypeahead.value = '';
      if (chainTypeahead) chainTypeahead.value = '';
      filterLocations();
    }

    function updateResultsSummary(locations) {
      if (!summaryEl) return;
      var total = allLocations.length;

      if (!locations.length) {
        summaryEl.textContent = '0 matching stockists of ' + total + ' total. Clear filters or broaden the area.';
        updateActiveFiltersSummary();
        return;
      }

      var grouped = groupByChainAndRegion(locations);
      var regions = {};

      locations.forEach(function (loc) {
        if (loc.store_region) {
          regions[loc.store_region] = true;
        }
      });

      var regionCount = Object.keys(regions).length;
      var chainCount = Object.keys(grouped).length;
      if (hasActiveFilters()) {
        summaryEl.textContent = locations.length + ' matching stockist' + (locations.length !== 1 ? 's' : '') + ' of ' + total + ' total across ' + regionCount + ' region' + (regionCount !== 1 ? 's' : '') + ' and ' + chainCount + ' retail partner' + (chainCount !== 1 ? 's' : '') + '.';
      } else {
        summaryEl.textContent = locations.length + ' stockists across ' + regionCount + ' region' + (regionCount !== 1 ? 's' : '') + ' and ' + chainCount + ' retail partner' + (chainCount !== 1 ? 's' : '') + '.';
      }
      updateActiveFiltersSummary();
    }

    function updateNetworkTotal() {
      networkTotalEls.forEach(function (element) {
        element.textContent = allLocations.length;
      });
      var distinctRegions = {};
      allLocations.forEach(function (location) {
        if (location.store_region) distinctRegions[location.store_region] = true;
      });
      var regionCount = Object.keys(distinctRegions).length;
      networkRegionEls.forEach(function (element) {
        element.textContent = regionCount;
      });
    }

    function formatLastUpdated(value) {
      if (!value) return '';
      var d = new Date(value);
      if (isNaN(d.getTime())) return '';
      try {
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' }).format(d);
      } catch (e) {
        var mm = String(d.getMonth() + 1).padStart(2, '0');
        var dd = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + mm + '-' + dd;
      }
    }

    function setLastUpdated(rawHeaderValue) {
      if (!lastUpdatedEl) return;
      var formatted = formatLastUpdated(rawHeaderValue);
      if (!formatted) {
        lastUpdatedEl.textContent = '';
        lastUpdatedEl.setAttribute('aria-hidden', 'true');
        return;
      }
      lastUpdatedEl.textContent = 'Last updated ' + formatted;
      lastUpdatedEl.setAttribute('aria-hidden', 'false');
    }

    function closeRegion(toggle, content) {
      toggle.setAttribute('aria-expanded', 'false');
      content.classList.remove('is-open');
      content.style.maxHeight = '';
      content.hidden = true;
    }

    function openRegion(toggle, content) {
      content.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = 'none';
      content.classList.add('is-open');
    }

    function closeAllRegions() {
      sectionEl.querySelectorAll('[data-region-toggle][aria-expanded=\"true\"]').forEach(function (toggle) {
        var regionSection = toggle.closest('.ag-locator__region-section');
        var content = regionSection ? regionSection.querySelector('[data-region-content]') : null;
        if (content) { closeRegion(toggle, content); }
      });
      toggleCollapseAllButton();
    }

    function initAccordions(options) {
      var revealMatches = Boolean(options && options.revealMatches);
      var toggles = sectionEl.querySelectorAll('[data-region-toggle]');

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var regionSection = this.closest('.ag-locator__region-section');
          var content = regionSection ? regionSection.querySelector('[data-region-content]') : null;
          var isExpanded = this.getAttribute('aria-expanded') === 'true';
          if (!content) return;
          if (isExpanded) {
            closeRegion(this, content);
            toggleCollapseAllButton();
            return;
          }
          openRegion(this, content);
          toggleCollapseAllButton();
        });
      });

      if (revealMatches) {
        toggles.forEach(function (toggle) {
          var regionSection = toggle.closest('.ag-locator__region-section');
          var content = regionSection ? regionSection.querySelector('[data-region-content]') : null;
          if (content) openRegion(toggle, content);
        });
        toggleCollapseAllButton();
        return;
      }

      var chainCards = sectionEl.querySelectorAll('.ag-locator__chain-card');
      if (chainCards.length === 1) {
        var onlyCard = chainCards[0];
        var togglesInCard = onlyCard.querySelectorAll('[data-region-toggle]');
        var firstContent = onlyCard.querySelector('[data-region-content]');
        if (togglesInCard.length === 1 && firstContent) {
          openRegion(togglesInCard[0], firstContent);
          toggleCollapseAllButton();
        }
      }
    }

    function searchableText(location) {
      return [
        location.store_name,
        location.store_address,
        location.store_chain,
        location.store_region
      ].filter(Boolean).join(' ').toLowerCase();
    }

    function filterLocations() {
      var searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
      var regionFilter = regionSelect ? regionSelect.value : 'all';
      var chainFilter = chainSelect ? chainSelect.value : 'all';

      var filtered = allLocations.filter(function (loc) {
        var matchesSearch = !searchTerm || searchableText(loc).indexOf(searchTerm) !== -1;
        var matchesRegion = regionFilter === 'all' || loc.store_region === regionFilter;
        var matchesChain = chainFilter === 'all' || loc.store_chain === chainFilter;
        return matchesSearch && matchesRegion && matchesChain;
      });

      updateResultsSummary(filtered);
      toggleResetButton();
      toggleCollapseAllButton();

      if (chainsContainer) {
        if (filtered.length === 0) {
          chainsContainer.innerHTML = renderEmptyState('no-results');
        } else {
          var revealMatches = hasActiveFilters();
          chainsContainer.innerHTML = renderChains(filtered, mapLinkText);
          initAccordions({ revealMatches: revealMatches });
        }
      }
      toggleCollapseAllButton();
    }

    function loadLocations() {
      if (!locationsUrl) return;

      if (chainsContainer) {
        chainsContainer.innerHTML = renderLoadingState();
      }
      if (summaryEl) {
        summaryEl.textContent = 'Loading live shelf list…';
      }
      setLastUpdated('');

      var controller = null;
      var timeoutId = null;
      if (typeof AbortController !== 'undefined') {
        controller = new AbortController();
        timeoutId = setTimeout(function () {
          try { controller.abort(); } catch (e) {}
        }, 10000);
      }

      fetch(locationsUrl, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (timeoutId) clearTimeout(timeoutId);
          if (!response.ok) throw new Error('HTTP ' + response.status);
          var headerValue = response.headers && (response.headers.get('last-modified') || response.headers.get('date')) || '';
          return response.json().then(function (data) {
            return { data: data, lastUpdated: headerValue };
          });
        })
        .then(function (payload) {
          if (payload && payload.data && payload.data.locations) { allLocations = payload.data.locations; }
          setLastUpdated(payload ? payload.lastUpdated : '');
          populateFilterOptions(allLocations);
          updateNetworkTotal();
          updateResultsSummary(allLocations);
          toggleResetButton();
          toggleCollapseAllButton();
          if (chainsContainer && allLocations.length > 0) {
            chainsContainer.innerHTML = renderChains(allLocations, mapLinkText);
            initAccordions();
          } else if (chainsContainer) {
            chainsContainer.innerHTML = renderEmptyState('no-data');
          }
        })
        .catch(function (err) {
          if (timeoutId) clearTimeout(timeoutId);
          var isTimeout = Boolean(err && err.name === 'AbortError');
          if (summaryEl) {
            summaryEl.textContent = isTimeout
              ? 'Live shelf list is slow to respond. Retry, or contact the team.'
              : 'Live shelf list unavailable. Retry, or contact the team.';
          }
          toggleResetButton();
          updateActiveFiltersSummary();
          if (chainsContainer) {
            chainsContainer.innerHTML = renderEmptyState(isTimeout ? 'timeout' : 'error');
          }
        });
    }

    // Video toggle + reduced motion (WCAG 2.2.2)
    var videoToggle = sectionEl.querySelector('[data-locator-video-toggle], [data-video-toggle]');
    var heroVid = sectionEl.querySelector('.ag-home-hero__video, .ag-locator__hero-video');
    if (videoToggle && heroVid && !videoToggle.hasAttribute('data-locator-video-bound')) {
      videoToggle.setAttribute('data-locator-video-bound', 'true');
      videoToggle.style.display = '';
      var pIcon = videoToggle.querySelector('.ag-home-hero__icon-pause, .ag-locator__icon-pause');
      var plIcon = videoToggle.querySelector('.ag-home-hero__icon-play, .ag-locator__icon-play');
      function showLocPaused() {
        if (pIcon) pIcon.style.display = 'none';
        if (plIcon) plIcon.style.display = 'block';
        videoToggle.setAttribute('aria-label', 'Play video');
      }
      function showLocPlaying() {
        if (pIcon) pIcon.style.display = 'block';
        if (plIcon) plIcon.style.display = 'none';
        videoToggle.setAttribute('aria-label', 'Pause video');
      }
      videoToggle.addEventListener('click', function() {
        if (heroVid.paused) { var p = heroVid.play(); if (p !== undefined) { p.then(showLocPlaying).catch(showLocPaused); } }
        else { heroVid.pause(); showLocPaused(); }
      });
      heroVid.addEventListener('play', showLocPlaying);
      heroVid.addEventListener('pause', showLocPaused);
      var locMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function handleLocMotion(mq) {
        heroVid.autoplay = !mq.matches;
        if (mq.matches) { heroVid.pause(); showLocPaused(); }
        else {
          var playback = heroVid.play();
          if (playback && playback.then) playback.then(showLocPlaying).catch(showLocPaused);
        }
      }
      handleLocMotion(locMotion);
      if (locMotion.addEventListener) { locMotion.addEventListener('change', handleLocMotion); }
      else if (locMotion.addListener) { locMotion.addListener(handleLocMotion); }
      if (heroVid.paused) { showLocPaused(); }
    }

    if (searchInput) {
      var searchTimer;
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(filterLocations, 200);
      });
    }
    if (resetButton) {
      resetButton.addEventListener('click', resetFilters);
    }
    if (collapseAllButton) {
      collapseAllButton.addEventListener('click', closeAllRegions);
    }

    function applyTypeahead(value, selectEl, inputEl) {
      if (!selectEl || !inputEl) return;
      var normalized = (value || '').trim();
      if (!normalized) {
        selectEl.value = 'all';
        inputEl.value = '';
        return;
      }
      for (var i = 0; i < selectEl.options.length; i += 1) {
        if (selectEl.options[i].value === normalized) {
          selectEl.value = normalized;
          inputEl.value = normalized;
          return;
        }
      }
      // If it doesn't match a known option, treat as "all" but keep what they typed.
      selectEl.value = 'all';
    }

    function createAutocomplete(inputEl, selectEl) {
      if (!inputEl || !selectEl) return null;

      var wrap = inputEl.closest('.ag-locator__select-wrapper');
      if (!wrap) return null;

      autocompleteInstanceCount += 1;
      var autocompleteId = 'ag-locator-autocomplete-' + autocompleteInstanceCount;
      var listId = autocompleteId + '-list';
      var panel = document.createElement('div');
      panel.className = 'ag-locator__autocomplete';
      panel.hidden = true;
      panel.id = autocompleteId;
      panel.innerHTML = '<ul class=\"ag-locator__autocomplete-list\" id=\"' + listId + '\" role=\"listbox\"></ul>';
      wrap.appendChild(panel);

      var list = panel.querySelector('.ag-locator__autocomplete-list');
      var options = [];
      var activeIndex = -1;

      inputEl.setAttribute('role', 'combobox');
      inputEl.setAttribute('aria-autocomplete', 'list');
      inputEl.setAttribute('aria-controls', listId);
      inputEl.setAttribute('aria-expanded', 'false');

      function updateOptions(values) {
        options = values || [];
        activeIndex = -1;
        inputEl.removeAttribute('aria-activedescendant');
        if (!panel.hidden) render();
      }

      function close() {
        panel.hidden = true;
        activeIndex = -1;
        inputEl.setAttribute('aria-expanded', 'false');
        inputEl.removeAttribute('aria-activedescendant');
      }

      function open() {
        if (!options.length) return;
        panel.hidden = false;
        inputEl.setAttribute('aria-expanded', 'true');
      }

      function render() {
        if (panel.hidden) return;
        var q = (inputEl.value || '').trim().toLowerCase();
        var matches = options.filter(function (v) { return !q || v.toLowerCase().indexOf(q) !== -1; }).slice(0, 10);
        if (!matches.length) {
          close();
          return;
        }
        list.innerHTML = matches.map(function (v, i) {
          var selected = (v === selectEl.value) ? 'true' : 'false';
          var active = (i === activeIndex) ? ' is-active' : '';
          return '<li class=\"ag-locator__autocomplete-item' + active + '\" id=\"' + listId + '-option-' + i + '\" role=\"option\" aria-selected=\"' + selected + '\" data-value=\"' + escapeHtml(v) + '\">' + escapeHtml(v) + '</li>';
        }).join('');
        open();
        if (activeIndex >= 0 && matches[activeIndex]) {
          inputEl.setAttribute('aria-activedescendant', listId + '-option-' + activeIndex);
        } else {
          inputEl.removeAttribute('aria-activedescendant');
        }
      }

      function choose(value) {
        applyTypeahead(value, selectEl, inputEl);
        filterLocations();
        close();
      }

      inputEl.addEventListener('focus', function () {
        panel.hidden = false;
        render();
      });

      inputEl.addEventListener('blur', function () {
        setTimeout(close, 120);
      });

      inputEl.addEventListener('input', function () {
        activeIndex = -1;
        inputEl.removeAttribute('aria-activedescendant');
        render();
      });

      inputEl.addEventListener('change', function () {
        applyTypeahead(inputEl.value, selectEl, inputEl);
        filterLocations();
        close();
      });

      inputEl.addEventListener('keydown', function (e) {
        if (panel.hidden) return;
        var items = Array.from(list.querySelectorAll('.ag-locator__autocomplete-item'));
        if (!items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, items.length - 1);
          render();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          render();
        } else if (e.key === 'Enter') {
          if (activeIndex >= 0 && items[activeIndex]) {
            e.preventDefault();
            choose(items[activeIndex].getAttribute('data-value') || '');
          }
        } else if (e.key === 'Escape') {
          close();
        }
      });

      panel.addEventListener('mousedown', function (e) {
        var item = e.target.closest('.ag-locator__autocomplete-item');
        if (!item) return;
        e.preventDefault();
        choose(item.getAttribute('data-value') || '');
      });

      return { updateOptions };
    }

    if (regionTypeahead && regionSelect) {
      regionAutocomplete = createAutocomplete(regionTypeahead, regionSelect);
    }

    if (chainTypeahead && chainSelect) {
      chainAutocomplete = createAutocomplete(chainTypeahead, chainSelect);
    }

    if (regionSelect && regionTypeahead) {
      regionSelect.addEventListener('change', function () {
        regionTypeahead.value = regionSelect.value !== 'all' ? regionSelect.value : '';
      });
    }

    if (chainSelect && chainTypeahead) {
      chainSelect.addEventListener('change', function () {
        chainTypeahead.value = chainSelect.value !== 'all' ? chainSelect.value : '';
      });
    }

    if (chainsContainer) {
      chainsContainer.addEventListener('click', function(event) {
        var resetInline = event.target.closest('[data-locator-reset-inline]');
        var retryButton = event.target.closest('[data-locator-retry]');

        if (resetInline) {
          resetFilters();
        }

        if (retryButton) {
          loadLocations();
        }
      });
    }
    if (regionSelect) { regionSelect.addEventListener('change', filterLocations); }
    if (chainSelect) { chainSelect.addEventListener('change', filterLocations); }
    if (chainsContainer) { loadLocations(); }
  }

  var sections = document.querySelectorAll('.ag-locator[data-locations-url]');
  for (var i = 0; i < sections.length; i += 1) {
    initLocator(sections[i]);
  }
})();
